import { selectStpRates } from '@va/aaas/shared/selectors';
import { useLastVisitDate } from '@va/dashboard/api-client/visits.api';
import { getFeaturePermissions } from '@va/dashboard/selectors/app';
import { activeWebsiteSelectors, selectWebsiteMonthlyVisits } from '@va/dashboard/selectors/core';
import { is3asApp } from '@va/util/helpers';
import { Dayjs } from 'dayjs';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export type LiveAndLimitData = {
  lastVisitDate: Dayjs | undefined;
  refetchLastVisitDate: () => void;
  limitReachedTimestamps: number[];
  isCurrentlyLimitReached: boolean;
};

export const useChartLiveAndLimitData = (): LiveAndLimitData => {
  const { data: lastVisitDate, mutate: refetchLastVisitDate } = useLastVisitDate();
  const limitReachedTimestamps = useSelector(activeWebsiteSelectors.selectVisitLimitReachedAt);

  const monthlyVisits = useSelector(selectWebsiteMonthlyVisits) ?? 0;
  const visitLimit = useSelector(getFeaturePermissions)?.visits?.limit;
  const stpRates = useSelector(selectStpRates);

  const isCurrentlyLimitReached = useMemo(() => {
    if (!is3asApp()) return visitLimit !== undefined && monthlyVisits >= visitLimit;

    const limit = stpRates?.pool ? stpRates.pool.limit : stpRates?.stpLimit;
    const consumed = stpRates?.pool ? stpRates.pool.consumed : stpRates?.stpConsumed;
    return consumed !== undefined && limit !== undefined && consumed >= limit;
  }, [monthlyVisits, stpRates?.pool, stpRates?.stpConsumed, stpRates?.stpLimit, visitLimit]);

  return { lastVisitDate, refetchLastVisitDate, limitReachedTimestamps, isCurrentlyLimitReached };
};
